var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"y":"227.5","style":{"fill":"#ffffff"},"width":"495","height":"40"}));
}

MinusInline.defaultProps = {"height":"24px","width":"24px","version":"1.1","viewBox":"0 0 495 495","xmlSpace":"preserve"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
